import { Subscription } from 'rxjs';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewChildren,
  QueryList,
  OnDestroy,
  SimpleChanges,
  DoCheck,
  AfterViewInit,
  AfterContentChecked,
} from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { InputDataModel } from 'dg-dynamic-grid-lib';
import { ComboPropConfig, DataPropConfig } from 'dg-input-lib';

import { HttpClient } from '@angular/common/http';
import { CommonService } from '../service/common.service';

import { ActivatedRoute, Router } from '@angular/router';
import { CommonComponent } from '../common/common.component';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { AppGenFormbuilderService } from '../../app-gen-formBuilder/service/app-gen-formbuilder.service';
import { ToastrService } from 'ngx-toastr';
import { getFilteredPostData } from 'src/app/digigov/dg_components/dg-questionnaire/dg-questionnaire.utils';
import { AppGenTabComponent } from '../app-gen-tab/app-gen-tab.component';
import { AppGenStepperComponent } from '../app-gen-stepper/app-gen-stepper.component';
import { ExecutionService } from '../service/execution.service';
import { ActionService } from 'src/app/digigov/services/worklist.service';
import { AppGenServiceService } from '../service/app-gen-service.service';
import { MessageDisplayService } from 'src/app/digigov/services/message-display/message-display.service';
import { DatePipe } from '@angular/common';
import { ComponentLoaderDirective } from 'src/app/component-loader.directive';
import { MatDialog } from '@angular/material/dialog';
import { RuleService } from '../service/rule.service';

interface ComboModel {
  id?: string | number;
  optionText: string;
  optionValue: string | number;
  optionDesc?: string;
  isRange?: boolean;
  optionDisabled?: boolean;
  optionIcon?: string;
}

export interface AdditionalVO {
  key?: string;
  value?: string;
}

@Component({
  selector: 'app-app-gen-main',
  templateUrl: './app-gen-main.component.html',
  styleUrls: ['./app-gen-main.component.scss'],
  providers: [
    RuleService,
    ExecutionService,
    AppGenServiceService,
    CommonService,
  ],
})
export class AppGenMainComponent
  implements OnInit, OnDestroy, DoCheck, AfterViewInit, AfterContentChecked {
  parentId = null;
  @ViewChild(CommonComponent) appCommon: CommonComponent;
  @ViewChild(AppGenTabComponent) appGenTab: AppGenTabComponent;
  @ViewChild(AppGenStepperComponent) appGenStepper: AppGenStepperComponent;
  @ViewChild(ComponentLoaderDirective)
  customComponentRef: ComponentLoaderDirective;
  isReadOnly: any = false;
  @ViewChildren('appGenDataList') appGenDataList;

  // @Input() res = this.data.data.resultValue.formDetails;
  // @Input() res: any = this.testdata.data.resultValue.formDetails;
  @Input() parentCommonService: CommonService;
  subscriptionForParentCommonService: Subscription;
  @Input() res: any;
  @Input() appGenSource: any;
  @Input() FORMID: string = '304';
  @Input() appId: any;
  @Input() formVersionId: any;
  @Input() formId: any;
  @Input() appRefId: any;
  // @Input() refId: string = '123456780';

  @Output('output') output = new EventEmitter<any>();
  @Output('ruleCondition') ruleCondition = new EventEmitter<any>();
  @Output('transactionData') transactionData = new EventEmitter<any>();

  formGroup: any = {};

  @Input() parentEventData;
  @Input() cases;
  @Input() data: any;
  @Input() caseVO: any;
  @Input() isCaseFormInputEnable: boolean = true;
  @Input() dataForPost: any;
  @Input() menuFetchData: any;
  @Input() qcaPassed: any;
  @Input() qcaFlag: any;
  @Output('refreshGrid') refreshGrid = new EventEmitter<any>();
  @Output('hideDevForm') hideDevForm = new EventEmitter<any>();
  @Input() fieldId: any;
  @Input() emitAppGenData: any;
  @Input() fileId = null;
  @Input() transactionId: any;

  //caseViewData = { "extendedVO": null, "customXidBean": null, "dbSchema": -1, "fileId": 130010110, "locId": 1, "langId": 1, "fileNo": "GoB1-TPH-0059-2022", "fileDesc": "Driver Licence-process", "deptId": 70002267, "sectionId": 70002267, "sectionName": "Taxi & Private Hire", "subjectId": 1500000213, "priorityId": 2, "statusId": 124, "confidentialityId": 72, "fileStageId": 130, "fileStageName": null, "fileCreatedDate": "2022-05-09T11:48:09.000+00:00", "dueDate": "2022-05-09T11:48:09.000+00:00", "disposalDate": null, "strDueDate": "05-09-2022 11:48:09", "classificationId": -1, "physicalFlag": 0, "arrivalDate": "", "arrivalTime": "", "fileArrived": "", "fileCreatedPostId": 33, "fileOwnerUnit": 100, "receivedFromPost": 33, "receivedFromPostName": "", "receivedDate": "2022-05-25T06:19:51.000+00:00", "jobId": 130371448, "lsbId": 1500000213, "noteFileTab": 1, "correspondenceTab": 0, "precedentCasesTab": 0, "draftsTab": 0, "refDocsTab": 0, "checkListTab": 0, "linkedFilesTab": 0, "communiqueTab": 0, "reminderTab": 0, "basicInfoTab": 0, "shadowfileId": -1, "shadowFileStatus": -1, "jmsFlag": -1, "applicationId": -1, "peshiUnit": -1, "peshiFlag": 0, "linkDelinkFlag": 0, "specialCases": -1, "movedToFolderId": -1, "objTypeId": -1, "openDt": null, "closeDt": null, "cutOffTimelimit": "", "deleteFlag": -1, "deleteRemarks": "", "disposalFlag": -1, "disposalType": -1, "disposalTimelimit": "", "archiveTimelimit": "", "activePartId": -1, "markType": -1, "markStartDt": null, "markEndDt": null, "markRemarks": "", "arrangementOnCol": null, "arrangementType": -1, "vitalRecords": -1, "legalRemarks": "", "restrictionFlag": -1, "aggregationRemarks": "", "reclassificationReason": "", "setForDisposition": -1, "setForDestruction": -1, "crtDt": "2022-05-09T11:48:09.000+00:00", "crtPost": 33, "lstUpdtDt": null, "lstUpdtPost": 33, "appliedByPostId": -1, "currentPost": -1, "appTypeId": -1, "applicationTypeId": 1, "fileTabId": 0, "empNo": 0, "designationId": 0, "activeFlag": 0, "subjectName": "Apply New PHV (Online)", "docType": null, "empNameWithDept": null, "actnDlvrDt": null, "deptShrtName": null, "priorityName": "Normal", "statusName": "Open", "sendToMany": 0, "crtUser": -1, "fromPost": 33, "newFlag": -1, "previouslySeenFlag": -1, "refFileNo": null, "isPartFile": null, "mainFileId": null, "retentionPeriod": null, "rcvdDate": null, "corrIds": null, "corrId": -1, "isShadowFile": -1, "adminFileId": -1, "collectionId": null, "collectionName": null, "alphaNumFileNo": null, "numFileNo": "00592022", "sentDate": null, "lstActOwnerUnit": null, "jobMvmntPk": -1, "lyingWith": "TCS ADMIN", "basicInfoURL": "ApproveRejectDriverLicence", "groupWorklistFlag": null, "approvalOrderNo": null, "approvalCycleCntr": null, "classificationName": null, "delegationVO": null, "manualFileNo": null, "legacyDataTab": 0, "priorityFlag1": null, "priorityFlag2": null, "priorityFlag3": null, "stageName": "Initial Review", "disposedDateWithTime": null, "sentOrRcvdDate": null, "category": 0, "fileCreatedUnitId": null, "prntFileId": null, "chckLstCompId": 4, "chckLstParam": { "formId": 407, "tId": null}, "notingsCorrespondence": null, "transOrgId": -1, "wfInstanceId": null, "wfEngine": 0, "microServiceBaseUrl": null, "appCategoryId": null, "chckLstCompName": "ApplyPhv", "applicationStatus": null, "applicationStatusName": null, "appStageId": null, "appStageName": null, "priorityFlag4": null, "priorityFilesDetailsLink": null, "mainfileTabId": 0, "fileDtlTabId": 0, "summaryTabId": 0, "queryTabId": 0, "keepWitdocTabId": 0, "previousTabId": 0, "isParlPhyPrc": null, "parlelPhyFileNo": null, "paginationVO": null, "numericFileNo": "00592022", "purposeFileTab": -1, "purposeFile": null, "purposeFileMpgPk": null, "authValuesMap": null, "shadowFileIndex": 0, "totalNotes": null, "collId": null, "resultFlag": "", "toCount": 0 }

  inputDataPropConfig: DataPropConfig = {
    idProp: 'fieldId',
    typeProp: 'fieldType',
    nameProp: 'label',
    placeholderProp: 'placeholder',
    requiredProp: 'isMandatory',
    comboProp: 'comboMapValues',
    validationsProp: 'validations',
    disabledProp: 'enableDisable',
    minLengthProp: 'minLength',
    maxLengthProp: 'maxLength',
    minProp: 'minLength',
    maxProp: 'maxLength',
    hintProp: 'matHint',
    readOnlyProp: 'readOnly',
  };

  @Input() additionalVOList: AdditionalVO[];
  comboPropConfig: ComboPropConfig = {
    labelProp: 'optionText',
    valueProp: 'optionValue',
    rangeProp: 'isRange',
    disabledProp: 'optionDisabled',
    iconProp: 'optionIcon',
  };

  showLabel = true;
  getDataFromRouting = false;
  tid = '';
  additionalVOListWithoutKeyValue: any = [];

  eventId = '1';
  preview: number = 0;
  doInit = true;

  @Output() appGenDataEmit = new EventEmitter<any>();
  additionalAttributeVO: any;
  developerFormData = null;
  constructor(
    private router: Router,
    private http: HttpClient,
    public commonService: CommonService,
    public execution: ExecutionService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    public appGenServiceService: AppGenServiceService,
    private authenticationService: AuthenticationService,
    private appGenFormbuilderService: AppGenFormbuilderService,
    private actionService: ActionService,
    private msgDsplyService: MessageDisplayService,
    public datePipe: DatePipe,
    private dialog: MatDialog
  ) {}
  ngAfterContentChecked(): void {}
  ngDoCheck(): void {
    if (this.emitAppGenData) {
      this.emitData(this.emitAppGenData);
    }
  }
  ngOnDestroy(): void {
    this.subscriptionForParentCommonService?.unsubscribe();
  }

  ngOnInit(): void {
    if (this.parentCommonService) {
      this.execution.parentCommonService = this.parentCommonService;

      this.commonService.parentCommonService = this.parentCommonService;
      this.execution.fieldId = this.fieldId;
      this.commonService.fieldId = this.fieldId;
    }
    this.subscriptionForParentCommonService = this.commonService?.notifyParentCommonServiceSubject
      ?.asObservable()
      ?.subscribe((data) => {
        if (this.parentCommonService)
          this.parentCommonService?.notifyParentCommonServiceSubject?.next(
            data
          );
        else if (data) {
          this.developerFormData = {
            ...this.developerFormData,
            [data?.fieldId]: data,
          };
          this.commonService.developerFormData = this.developerFormData;
          this.commonService.parentCommonService = this.parentCommonService;
          this.execution.developerFormData = this.developerFormData;
          this.execution.parentCommonService = this.parentCommonService;

          localStorage.setItem(
            'developerFormData',
            JSON.stringify(this.developerFormData)
          );
        }
      });
    this.commonService.comboMapValues = {};
    this.execution.parentEventData = this.parentEventData;
    this.execution.caseVO = this.caseVO;
    this.execution.cases = this.cases;
    this.execution.menuFetchData = this.menuFetchData;
    this.data = {
      ...this.data,
      ...{
        qcaPassed: this.qcaPassed,
        qcaFlag: this.qcaFlag,
        fileStageId: this.data?.stageId
          ? this.data?.stageId
          : this.caseVO?.fileStageId,
        statusId: this.data?.statusId ? this.data?.statusId : this.data?.status,
      },
    };
    this.execution.inputCaseViewdata = this.data;
    this.commonService.appGenFormGroup = new FormGroup({});
    this.execution.appFormId = this.formId;
    this.execution.appRefId = this.appRefId;
    this.commonService.inputCaseViewdata = this.data;
    this.commonService.parentEventData = this.parentEventData;
    this.commonService.cases = this.cases;

    this.commonService.caseVO = this.caseVO;
    this.commonService.isCaseForm = this.isCaseFormInputEnable;
    this.commonService.dataForPost = this.dataForPost;
    this.commonService.menuFetchData = this.menuFetchData;
    this.execution.dataForPost = this.dataForPost;
    if (this.additionalVOList == null) {
      this.additionalVOList = [];
    }
    const dataAttributeArray = [
      'additionalAttribute1',
      'additionalAttribute2',
      'additionalAttribute3',
      'additionalAttribute4',
      'additionalAttribute5',
      'additionalAttribute6',
      'additionalAttribute7',
      'additionalAttribute8',
      'additionalAttribute9',
      'additionalAttribute10',
      'applicationStatus',
      'appId',
      'appStageId',
    ];
    if (this.data != undefined) {
      let additionalAttributeJsonObj = {};
      for (const key in this.data) {
        if (Object.prototype.hasOwnProperty.call(this.data, key)) {
          if (dataAttributeArray.includes(key)) {
            let additionalVO: AdditionalVO = {
              key: '',
              value: '',
            };
            additionalVO.key = key;
            additionalVO.value = this.data[key];
            additionalAttributeJsonObj[key] = this.data[key];
            this.additionalVOListWithoutKeyValue = additionalAttributeJsonObj;
            this.additionalVOList.push(additionalVO);
          }
        }
      }
    }
    let additionalVO: AdditionalVO = {
      key: 'fileId',
      value: this.caseVO?.fileId ? this.caseVO?.fileId : this.caseVO?.docId,
    };
    let additionalVO1: AdditionalVO = {
      key: 'qcaPassed',
      value: this.qcaPassed,
    };
    let additionalVO2: AdditionalVO = {
      key: 'qcaFlag',
      value: this.qcaFlag,
    };
    let additionalVO3: AdditionalVO = {
      key: 'fileStageId',
      value: this.caseVO?.fileStageId,
    };
    let additionalVO4: AdditionalVO = {
      key: 'statusId',
      value: this.caseVO?.statusId,
    };
    let additionalVO5: AdditionalVO = {
      key: 'applicationStatusName',
      value: this.caseVO?.applicationStatusName,
    };

    this.additionalVOListWithoutKeyValue['fileId'] = this.caseVO?.fileId;
    this.additionalVOList.push(additionalVO);
    this.additionalVOList.push(additionalVO1);
    this.additionalVOList.push(additionalVO2);
    this.additionalVOList.push(additionalVO3);
    this.additionalVOList.push(additionalVO4);
    this.additionalVOList.push(additionalVO5);
    this.commonService.additionalVOList = this.additionalVOList;
    this.actionService.skipClicked.subscribe((res) => {
      if (res) {
        this.refreshGrid.emit(true);
      }
    });

    let formExecuted = false;
    if (this.formId != undefined) {
      this.getDataFromRouting = false;
      formExecuted = true;
      let tid = this.appRefId;
      this.FORMID = this.formId;
      this.eventId = '23';
      this.commonService.fileId = this.caseVO?.fileId
        ? this.caseVO?.fileId?.toString()
        : this.caseVO?.docId?.toString();
      this.fileId = this.caseVO?.fileId
        ? this.caseVO?.fileId?.toString()
        : this.caseVO?.docId
        ? this.caseVO?.docId?.toString()
        : this.fileId;

      this.appGenServiceService.setAppGenData(
        'additionalAttributeVO',
        this.additionalVOList
      );
      this.appGenServiceService.setAppGenData(
        'fileId',
        this.appGenSource != 'openDialog' ? this.fileId : this.fileId
      );
      this.loadData(tid);
    }

    this.activatedRoute.queryParams.subscribe((res) => {
      if (res?.formId != undefined && res?.formId != null) {
        if (this.formId == undefined && this.appRefId == undefined) {
          this.getDataFromRouting = true;
          formExecuted = true;
          this.FORMID = res?.formId;
          this.appId = res?.appId;
          this.formVersionId = res?.formVersionId;
          this.commonService.cmnFormId = res?.formId;
          this.commonService.tId = res?.transactionId;
          this.preview = res?.preview * 1;
          if (
            this.commonService.tId == null ||
            this.commonService.tId == undefined
          ) {
            this.appGenServiceService.appGenData = {};
          }
          let tid = res?.transactionId;
          this.eventId = res?.eventId;
          this.loadData(tid);
        }
      }
    });

    if (!formExecuted) {
      if (this.caseVO != null) {
        this.FORMID = this.caseVO?.chckLstParam?.formId?.toString();
        this.commonService.cmnFormId = this.caseVO?.chckLstParam?.formId?.toString();
        this.commonService.fileId = this.caseVO?.fileId
          ? this.caseVO?.fileId?.toString()
          : this.caseVO?.docId?.toString();
        this.fileId = this.caseVO?.fileId
          ? this.caseVO?.fileId?.toString()
          : this.caseVO?.docId?.toString();

        this.appGenServiceService.setAppGenData(
          'fileId',
          this.appGenSource != 'openDialog' ? this.fileId : null
        );
        this.appGenServiceService.setAppGenData(
          'additionalAttributeVO',
          this.additionalVOList
        );
        let jsonForEvent = {
          formId: this.FORMID,
          appRefId: '',
          fileId: this.fileId,
        };
        if (this.fileId != null && this.fileId != undefined) {
          this.appGenServiceService
            .requestEventID(jsonForEvent)
            .subscribe((res: any) => {
              this.eventId = res.data.eventId;
              this.loadData();
            });
        } else {
          this.loadData();
        }
      }
    }
  }

  loadData(tid?) {
    if (this.transactionId != undefined) {
      tid = this.transactionId;
    }

    this.appGenServiceService
      .getFormData(
        this.eventId,
        this.FORMID,
        tid,
        this.appGenSource != 'openDialog' ? this.fileId : null,
        this.additionalVOList,
        this.preview
        // this.refId
      )
      .subscribe(
        (res: any) => {
          if (res.data.status) {
            this.msgDsplyService.errorToast({
              errors: [
                {
                  message: res.messages?.[0],
                },
              ],
            });
            let url =
              'main/appgen-form-version?formIdToSend=' +
              this.FORMID +
              '&appId=' +
              this.appId;
            this.router.navigateByUrl(url);
          } else {
            this.commonService.resultValue = res.data.resultValue;
            this.commonService.inputJsonData = res.data.resultValue.formDetails;
            this.commonService.cmnFormId = res.data.resultValue.formId;
            this.commonService.additionalVOList = this.additionalVOList;
            this.commonService.additionalVOListWithoutKeyValue = this.additionalVOListWithoutKeyValue;
            this.res = res.data.resultValue.formDetails;
            this.FORMID = res.data.resultValue.formId;
            this.commonService.eventId = res.data.resultValue.eventId;
            this.eventId = res.data.resultValue.eventId;
            let additionalVO: AdditionalVO = {
              key: 'appId',
              value: res.data.resultValue.cmnFormMd.appId,
            };
            this.additionalVOList.push(additionalVO);
            this.commonService.additionalVOList = this.additionalVOList;
            this.appId = res.data.resultValue.cmnFormMd.appId;
            this.commonService.isReadOnly = this.isReadOnly;
            if (this.data?.editable) {
              this.isReadOnly = this.data?.editable;
              this.commonService.isReadOnly = this.data?.editable;
              this.commonService.compMap(this.res, this.isReadOnly);
            } else {
              this.commonService.compMap(this.res, this.isReadOnly);
            }
            let transId = res.data.resultValue.trans;
            this.tid = res.data.resultValue.appRefId;
            // this.tid = res.data.resultValue?.idVal;
            this.commonService.initializeFormId(
              this.FORMID,
              this.tid,
              this.appId,
              this.res
            );
            // this.refId

            //Managing enableDisable of components based on the role
            res?.data?.resultValue?.formDetails?.forEach((component) => {
              this.checkView(component);
            });
            this.commonService.initializeFormGroup(this.res, false);
            this.execution.initializeCombo(this.res);
            this.execution.initializeVisibilityRule(this.res);
            this.execution.initializeVisibilityRuleForTabComponent(this.res);
            this.execution.initializeAdvanceVisibilityRule(this.res);
            //check page Onload or not
            this.commonService.onLoadEvent = true;
            this.execution.initializeVisibilityRuleForHiddenComponent(this.res);
            // this.commonService.initializeLoadEvent(this.res);
            this.hideDevForm.emit({ fieldId: this.fieldId });

            //After load Completed set false
            this.commonService.onLoadEvent = false;
          }
        },
        (err: any) => {
          console.error('Error in renderApi', err);
        }
      );
  }
  checkView(component: any) {
    if (component?.children?.length > 0) {
      for (const iterator of component.children) {
        this.checkView(iterator);
      }
    }
    if (component?.attribute?.isView == true) {
      component.attribute.enableDisable = true;
    }
    this.commonService.roleBasedView(component, component?.attribute?.isView);
  }

  ngAfterViewInit(): void {
    this.execution.customCompRef = this.customComponentRef;
  }
  emitData(event?: any) {
    let placeholderMap = this.commonService.getEntityAttributeMapData(
      this.commonService.resultObj,
      this.appGenServiceService.getAppGenData(
        this.formId,
        this.commonService.tid
      ),
      true,
      false,
      false,
      false,
      false,
      'dd MMMM yyyy'
    );
    let plmap = this.commonService.getEntityAttributeMapData(
      this.commonService.resultObj,
      this.appGenServiceService.getAppGenData(
        this.formId,
        this.commonService.tid
      ),
      true,
      false,
      false,
      false,
      true,
      'dd MMMM yyyy'
    );
    this.appGenDataEmit.emit({
      placeholderMap: placeholderMap,
      plmap: plmap,
      isValid: this.commonService.appGenFormGroup.valid,
      developerFormData: event,
    });
  }
  appGenDataEmitFromCheckList(event) {
    this.emitData(event);
  }
  appGenDataEmitFromDevForm(event) {
    this.emitData(event);
  }
  appGenDataEmitFromTab(event) {
    this.emitData(event);
  }

  onKeyPress(event) {
    return this.commonService.hashRestrict(event);
  }

  onInputChange = (data, eventName) => {
    // Application Developer's code ;-)

    let parentId;
    let parentIdKey: any;
    let childIdKey: any;
    let parentIdR: any;
    let childIdR: any;
    if (data?.fieldType == 0) {
      let tempDate = this.commonService.appGenFormGroup.controls[data.fieldId]
        .value;
      if (tempDate != null) {
        tempDate = this.datePipe.transform(new Date(tempDate), 'yyyy-MM-dd');
        this.commonService.appGenFormGroup.controls[data.fieldId].setValue(
          tempDate
        );

        // For date valildation
        data?.attribute?.validations?.forEach((comp) => {
          this.commonService.dateValidation(
            comp.validationId,
            comp.cmpFormId,
            comp.otherCmpFormId,
            data,
            true
          );
        });
      }
    }

    this.appGenServiceService.setAppGenData(
      data.fieldId,
      this.commonService.appGenFormGroup.controls[data.fieldId].value
    );
    this.appGenDataEmit.emit(
      this.commonService.getEntityAttributeMapData(
        this.commonService.resultObj,
        this.appGenServiceService.getAppGenData(
          this.formId,
          this.commonService.tid
        ),
        true
      )
    );

    if (
      data?.attribute.fieldId.toString() == parentIdR &&
      this.commonService.appGenFormGroup.controls[childIdR].value
    ) {
      this.commonService.appGenFormGroup.controls[childIdR].reset();
    }

    // data?.dependentComboList?.forEach((depEle) => {
    //   if (element.fieldId == depEle) {
    //     Object.keys(element?.attribute?.comboConfigurationString).forEach(
    //       (key) => {
    //         if (
    //           element?.attribute?.comboConfigurationString[key].startWith(
    //             'ComponentId_'
    //           )
    //         ) {
    //           let childId = element?.attribute?.comboConfigurationString[
    //             key
    //           ].split('_')[1];
    //           element.attribute.comboConfigurationString[
    //             key
    //           ] = this.commonService.appGenFormGroup.controls[childId].value;
    //         }
    //       }
    //     );
    //     this.appGenServiceService
    //       .setDropDown(
    //         element?.attribute?.comboMap,
    //         element?.attribute?.comboConfigurationString
    //       )
    //       .subscribe(
    //         (res: any) => {
    //           element.attribute.comboData = res.data;
    //         },
    //         (err) => {
    //           console.error(err);
    //         }
    //       );
    //   }
    // });

    data?.cmnFormFieldEventList?.forEach((event) => {
      if (event.eventName == eventName) {
        this.commonService.findcomboStringObj(this.res, data);

        this.execution.executeEventService(
          event?.cmnEventExecutionList,
          this.commonService.appGenFormGroup,
          data,
          null,
          this.tid,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
      }
    });
  };

  callSaveApi() {
    this.appGenServiceService
      .saveData(this.appGenServiceService.getAppGenData(this.FORMID, this.tid))
      .subscribe(
        (res: any) => {
          this.transactionData.emit(res);
          this.msgDsplyService.successToast({
            messages: ['Form Saved Succesfully'],
          });
          this.appGenServiceService.appGenData = {};
          let url = '';
          if (this.formVersionId == null || this.formVersionId == undefined) {
            url = 'main/app-gen/form';
            this.router.navigate([url], {
              queryParams: {
                formIdToSend: this.FORMID,
                appId: this.appId,
                formStatus: true,
              },
            });
          } else {
            url = 'main/app-gen/form';
            this.router.navigate([url], {
              queryParams: {
                formIdToSend: this.FORMID,
                appId: this.appId,
                formStatus: true,
                formVersionId: this.formVersionId,
              },
            });
          }
        },
        (err: any) => {
          this.msgDsplyService.errorToast({
            errors: [
              {
                message: 'Oops! Something went wrong',
              },
            ],
          });

          console.error('Error in renderApi', err);
        }
      );
  }
  getKeys(map: any) {
    if (map) return Object.keys(map);
  }
  quetionarObj: any = null;
  checkQuestionnaire(checkListObj) {
    let tempArray;

    this.getKeys(checkListObj).forEach((attributes, index) => {
      if (Array.isArray(checkListObj[attributes])) {
        checkListObj[attributes][0].displayOrder = attributes;

        this.checkQuestionnaire(checkListObj[attributes]);
      }
      if (!Array.isArray(checkListObj[attributes])) {
        checkListObj[attributes].displayOrder = attributes;
        if (checkListObj[attributes].fieldType == 103) {
          this.quetionarObj = checkListObj[attributes];
          return this.quetionarObj;
        }
      }
      if (Array.isArray(checkListObj[attributes].children)) {
        this.checkQuestionnaire(checkListObj[attributes].children);
      }
    });
    return this.quetionarObj;
  }

  onClose() {
    let url = '';

    if (this.formVersionId == null || this.formVersionId == undefined) {
      url = 'main/appgen-main-container';
      this.router.navigate([url], {
        queryParams: {
          formIdToSend: this.FORMID,
          appId: this.appId,
          formStatus: true,
        },
      });
    } else {
      url = 'main/appgen-main-container';
      this.router.navigate([url], {
        queryParams: {
          formIdToSend: this.FORMID,
          appId: this.appId,
          formStatus: true,
          formVersionId: this.formVersionId,
        },
      });
    }
  }
  onSave() {
    var quesObj;
    if (this.appGenStepper?.stepData)
      quesObj = this.checkQuestionnaire(this.appGenStepper?.stepData);

    if (
      this.appGenStepper?.appGenTabComponent?.appCommon?.res?.fieldType ==
        103 ||
      this.appCommon?.res?.fieldType == 103 ||
      this.appGenTab?.appCommon?.res?.fieldType == 103 ||
      this.appGenStepper?.appCommon?.res?.fieldType == 103 ||
      this.appGenStepper?.appGenStepperComponent?.appCommon?.res?.fieldType ==
        103
    ) {
      const msg = {
        type: 'get',
        questionnaireConfig: null,
      };
      this.appCommon?.parentEvent.next(msg);
      this.appGenTab?.appCommon?.parentEvent.next(msg);
      this.appGenStepper?.appCommon?.parentEvent.next(msg);
      this.appGenStepper?.appGenStepperComponent?.appCommon?.parentEvent.next(
        msg
      );
      this.appGenStepper?.appGenTabComponent?.appCommon?.parentEvent.next(msg);

      let questObj;
      questObj =
        this.appCommon ||
        this.appGenTab?.appCommon ||
        this.appGenStepper?.appCommon ||
        this.appGenStepper?.appGenStepperComponent?.appCommon ||
        this.appGenStepper?.appGenTabComponent?.appCommon;

      let dataForPost = {
        surveyId: questObj.questionnaireData?.['surveyId'],
        surveyTypeId: questObj.questionnaireData?.['surveyTypeId'],
        surveyDtlId: questObj.questionnaireData?.['surveyDtlId'],
        stakeHolderId: Number(this.authenticationService.loggedInUser.EMP_ID),
        stakeHolderTypeId: 101013,
        lTemplateId: questObj.questionnaireData?.['lTemplateId'],
        surveyResponseVO: {
          status: 'save',
          surveyRespTrnId: questObj?.res?.defaultValue || '',
        },
        questionMap: questObj.questionnaireData?.['questionMap'],
      };
      dataForPost = getFilteredPostData(dataForPost);
      this.appGenFormbuilderService
        .submitAndSaveQuestionnaire(dataForPost)
        .subscribe(
          (res: any) => {
            this.appGenServiceService.setAppGenData(
              questObj?.res?.fieldId,
              res || questObj?.res?.defaultValue
            );
            this.callSaveApi();
          },
          (err) => {
            console.error('survey save failed: ', err);
          }
        );
    } else {
      if (this.commonService.appGenFormGroup.valid) {
        this.callSaveApi();
      } else {
        this.commonService.appGenFormGroup.markAllAsTouched();

        this.msgDsplyService.errorToast({
          errors: [
            {
              message: 'Please Enter Mandatory controls',
            },
          ],
        });
      }
    }
  }

  getTransId(data) {
    if (data != null) {
      this.tid = data;
    }
  }

  getChckLstComponentData(cheklistData) {
    if (cheklistData[0]?.from === 'output') {
      this.output.emit(cheklistData[0]?.data);
    }
    if (cheklistData[0]?.from === 'ruleCondition') {
      this.ruleCondition.emit(cheklistData[0]?.data);
    }
    if (cheklistData[0]?.from === 'refreshGrid') {
      this.refreshGrid.emit(cheklistData[0]?.data);
    }
  }

  // async eventCall(name: string) {
  //   if (name) {
  //     const a = await import('../app-gen/service/test1.service');
  //     const dynamicService = new a['Test1Service']();
  //     name.split(';').forEach((ele) => {
  //       if (ele) {
  //         // dynamicService.validateTextInput();
  //         eval('dynamicService.' + ele);
  //       }
  //       // eval("this.appGenServiceService." + ele);
  //     });
  //   }
  // }
}
